export enum Environment {
    Local = 'Local',
    Test = 'Test',
    UAT = 'Uat',
    Staging = 'Staging',
    Prod = 'Prod',
}
